import React from "react";
import ReactDOM from "react-dom";
import './cssThemes.css';
import "./index.css";
import App from './components/app/app';

ReactDOM.render(<div className="default-theme"><App /></div>, document.getElementById('root'))